import HomeView from '@/views/HomeView.vue'

export const moduleRoutes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/planos',
    name: 'planos',
    component: () => import('@/views/PlansView.vue'),
  },
  {
    path: '/contato',
    name: 'contato',
    component: () => import('@/views/ContactWe.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notfound',
    component: () => import('@/views/NotFound.vue'),
  },
]
